import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

import type {
  GetUploadsQuery,
  GetUploadsQueryVariables,
} from '#/graphql/generated';

export const GET_UPLOADS: TypedDocumentNode<
  GetUploadsQuery,
  GetUploadsQueryVariables
> = gql`
  query GetUploads($limit: Int) {
    uploads(limit: $limit) {
      id
      resourceId
      filename
      createdAt
      documentId
      documentPath
      url
      isEncrypted
      draft
    }
  }
`;
